// extracted by mini-css-extract-plugin
export default {"grid-ul":"AutomationsGrid_grid-ul__LtioF","grid-li":"AutomationsGrid_grid-li__Uj97L"};